import { combineReducers } from 'redux';
import { PaymentsState } from './types';
import { commonPaymentsReducer } from './common/reducers';
import { recipientPaymentsReducer } from './recipient/reducers';

export const paymentsReducer = combineReducers<PaymentsState>({
  common: commonPaymentsReducer,
  recipient: recipientPaymentsReducer
});